import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ClientLookup from '../../components/Form/ClientLookup';
import * as naviActions from '../../redux/modules/navi';
import * as tabActions from '../../redux/modules/tabs';
import ButtonToolbar from '../../components/ButtonToolbar';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch),
				naviActions: bindActionCreators(naviActions, dispatch),
				tabActions: bindActionCreators(tabActions, dispatch)}
	}, null, {withRef: true })
export default class Form extends FormDB {

	/*static contextTypes= {
		router: React.PropTypes.object
	};*/

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'vehicle.fetch',
			save: 'vehicle.save',
			remove: 'vehicle.delete'
		};

		this.changeEvent = 'vehicle.change';

		this.messages = {
			remove: 'Opravdu si přejete vozík odstranit?',
			notfound: 'Vozík nenalezen!'
		};

		this.schema = {
			client: {
				class: ClientLookup,
				addButton: true,
				label: 'Provozovatel'
			},
			eid: {
				class: TextInput,
				label: 'Podnikové číslo'
			},
			make: {
				class: TextInput,
				label: 'Výrobce'
			},
			model: {
				class: TextInput,
				label: 'Typové označení'
			},
			year: {
				class: Number,
				label: 'Rok výroby'
			},
			engine: {
				class: TextInput,
				label: 'Číslo motoru'
			},
			serial: {
				class: TextInput,
				label: 'Výrobní číslo'
			},
			column_serial: {
				class: TextInput,
				label: 'Výrobní číslo sloupu'
			},
			column_extra: {
				class: TextInput,
				label: 'Dodatkové číslo sloupu'
			},
			notice: {
				class: TextInput,
				label: 'Poznámka'
			},
			files: {
				class: FileUpload,
				label: 'Přílohy'
			},
      ev: {
        class: TextInput,
        label: 'Ev. č.'
      }
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.ev});
	}

	handleAddTech() {
		const vehicle = {id: this.props.id, text: this.props.id};
		this.props.tabActions.openTabForm('techtest', 'Nová', {id:0, vehicle: vehicle});
	}

	onSave(data) {
		if (this.props.onSave) {
			this.form.reset();
			this.props.onSave(data);
		}
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];


		const values = this.form.getValues().toJS();

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					{!this.props.popup && <Toolbar title="Vozík">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>}
					<div className="row">
						<div className={!this.props.popup ? 'col-xs-7' : ''}>
							<table className="form">
								<tbody>
								{this.props.id > 0 &&
									<tr>
										<th>
											Evidenční číslo
										</th>
										<td>
											{values.ev}
										</td>
									</tr>}
								{Object.keys(this.schema).filter((key) => key != 'ev').map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={160}/>
								})}
								</tbody>
							</table>
						</div>
					</div>
					{!this.props.popup &&
					<div style={{textAlign:'right'}}>
						{saveCloseButton}
					</div>}
					{this.props.popup &&
					<div className="modal-footer" style={{margin: -20, marginTop: 20}}>
						<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
						{saveCloseButton}
					</div>}
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Vehicle/Form.js